import { createRouter,createWebHashHistory } from "vue-router";
import homeView from "@/components/page/homeView";
import topicView from "@/components/page/topicView";
import examView from "@/components/page/examView";

const routes = [
  {
    path:'/home',
    name:'homeView',
    component:homeView
  },
  {
    path:'/topic/:gid?',
    name:'topicView',
    component:topicView

  },
  {
    path: '/exam/:exam_gid?',
    name: 'examView',
    component: examView
  },
  {
    path:'/',
    redirect:'/home'
  }
]

const router = createRouter({
  history:createWebHashHistory(),
  routes,
  mode: 'history'
})

export default router

